import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToTop } from '../../../utils/smoothScroll';

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, App.jsx will handle scrolling to it with an offset.
    // Only scroll to the very top if there's no hash.
    if (!hash) {
      // Use our scroll function
      scrollToTop('auto');
    }
  }, [pathname, hash]);

  return null;
}
